
<div v-if="boardItemHasConnections()">
  <div class="label mt-4 mb-1">
    <div class="container">
      <div class="row">
        <h5>
          <b-badge>Links</b-badge>
          <i class="far fa-link ml-2"></i>
        </h5>
      </div>
    </div>
  </div>

  <div v-if="boardItem.parentBoardItem">
    <router-link
      :to="{
        name: 'BoardItemDetail',
        params: { itemid: boardItem.parentBoardItem.id },
      }"
    >
      {{ boardItem.parentBoardItem.title }}
    </router-link>
  </div>
  
  <div v-for="item in boardItem.linkedBoardItems" :key="item.id">
    <router-link
      :to="{
        name: 'BoardItemDetail',
        params: { itemid: item.id },
      }"
    >
      {{ item.title }}
    </router-link>
  </div>
</div>
